import { s as size, g as getSizePresetFromNextTokens } from '../../dist/text-f2f449ee.esm.js';
export { c as buttonColor, e as buttonEqualSizes, f as buttonFill, a as buttonShape, b as buttonShapeEqual, d as buttonSize, h as buttonSizes, i as checkboxSize, i as controlSize, j as headingSize, c as iconButtonColor, f as iconButtonFill, b as iconButtonShape, d as iconButtonSize, s as iconSize, k as listSize, l as loaderSizes, m as progressSize, v as progressVariant, i as radioSize, i as sliderSize, n as tabSize, o as textSize } from '../../dist/text-f2f449ee.esm.js';
import _pick from 'ramda/src/pick';
import _map from 'ramda/src/map';
import capsizesJson from '@hover/tokens-typography/assets/capsizes.next.json';
import * as tokens$1 from '@hover/tokens-typography/next';
import { fromEntries } from '@hover/utilities';
import '@hover/tokens-depth';
import '@hover/tokens-depth/bauhaus';
export { p as borderPreset, a as borderPresets, b as borderWidths, c as breakpoints, h as colorHues, n as colorHuesNeutral, d as colorPalettes, s as colorSchemes, e as colorSchemesBrand, f as colorSchemesNeutral, g as colorSchemesProduct, m as motion } from '../../dist/borders-5cad425b.esm.js';
import '@hover/tokens-border';
export { s as shadows } from '../../dist/shadows-714a8df5.esm.js';
import '@hover/tokens-size';
import '@hover/tokens-space';
import '@hover/tokens-typography';
import * as tokens from '@hover/tokens-color/next';
export { tokens as colorTokens };
import * as tokens$2 from '@hover/tokens-border/next';
import * as tokens$3 from '@hover/tokens-size/next';
import * as tokens$4 from '@hover/tokens-space/next';
import '../../dist/unsupportedIterableToArray-4cf0be12.esm.js';
import '@hover/tokens-typography/assets/capsizes.json';
import '@hover/tokens-size/bauhaus';
import '@hover/tokens-device';
import '@hover/tokens-color';
import '@hover/tokens-motion';

var presets$1 = {
  100: {
    color: tokens$1.heading100Color,
    fontFamily: tokens$1.heading100Family,
    fontSize: tokens$1.heading100Size,
    fontWeight: tokens$1.heading100Weight,
    lineHeight: tokens$1.heading100Height,
    marginBottom: tokens$1.heading100Margin,
    letterSpacing: tokens$1.heading100LetterSpacing
  },
  200: {
    color: tokens$1.heading200Color,
    fontFamily: tokens$1.heading200Family,
    fontSize: tokens$1.heading200Size,
    fontWeight: tokens$1.heading200Weight,
    lineHeight: tokens$1.heading200Height,
    marginBottom: tokens$1.heading200Margin,
    letterSpacing: tokens$1.heading200LetterSpacing
  },
  300: {
    fontWeight: tokens$1.heading300Weight,
    fontFamily: tokens$1.heading300Family,
    color: tokens$1.heading300Color,
    fontSize: tokens$1.heading300Size,
    lineHeight: tokens$1.heading300Height,
    marginBottom: tokens$1.heading300Margin,
    letterSpacing: tokens$1.heading300LetterSpacing
  },
  400: {
    fontWeight: tokens$1.heading400Weight,
    color: tokens$1.heading400Color,
    fontFamily: tokens$1.heading400Family,
    fontSize: tokens$1.heading400Size,
    lineHeight: tokens$1.heading400Height,
    marginBottom: tokens$1.heading400Margin,
    letterSpacing: tokens$1.heading400LetterSpacing
  },
  500: {
    fontWeight: tokens$1.heading500Weight,
    color: tokens$1.heading500Color,
    fontFamily: tokens$1.heading500Family,
    fontSize: tokens$1.heading500Size,
    lineHeight: tokens$1.heading500Height,
    marginBottom: tokens$1.heading500Margin,
    letterSpacing: tokens$1.heading500LetterSpacing
  },
  600: {
    fontWeight: tokens$1.heading600Weight,
    color: tokens$1.heading600Color,
    fontFamily: tokens$1.heading600Family,
    fontSize: tokens$1.heading600Size,
    lineHeight: tokens$1.heading600Height,
    marginBottom: tokens$1.heading600Margin,
    letterSpacing: tokens$1.heading600LetterSpacing
  },
  /**
   * @deprecated use 600
   */
  650: {
    fontWeight: tokens$1.heading650Weight,
    color: tokens$1.heading650Color,
    fontFamily: tokens$1.heading650Family,
    fontSize: tokens$1.heading650Size,
    lineHeight: tokens$1.heading650Height,
    marginBottom: tokens$1.heading650Margin,
    letterSpacing: tokens$1.heading650LetterSpacing
  },
  700: {
    fontWeight: tokens$1.heading700Weight,
    color: tokens$1.heading700Color,
    fontFamily: tokens$1.heading700Family,
    fontSize: tokens$1.heading700Size,
    lineHeight: tokens$1.heading700Height,
    marginBottom: tokens$1.heading700Margin,
    letterSpacing: tokens$1.heading700LetterSpacing
  },
  800: {
    fontWeight: tokens$1.heading800Weight,
    color: tokens$1.heading800Color,
    fontFamily: tokens$1.heading800Family,
    fontSize: tokens$1.heading800Size,
    lineHeight: tokens$1.heading800Height,
    marginBottom: tokens$1.heading800Margin,
    letterSpacing: tokens$1.heading800LetterSpacing
  },
  900: {
    fontWeight: tokens$1.heading900Weight,
    color: tokens$1.heading900Color,
    fontFamily: tokens$1.heading900Family,
    fontSize: tokens$1.heading900Size,
    lineHeight: tokens$1.heading900Height,
    marginBottom: tokens$1.heading900Margin,
    letterSpacing: tokens$1.heading900LetterSpacing
  }
};
var aliases$1 = {
  xs: 100,
  small: 200,
  medium: 400,
  large: 600,
  xl: 700,
  xxl: 900
};
var sizes$3 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight', 'letterSpacing']), presets$1);
var capsizes$1 = capsizesJson.heading;

// TODO(default-size): deprecate `default` size in all size maps and export
// member from `size` (e.g: `export defaultSize = 'small'`) tuple instead (to
// be passed as `defaultProp` in Chakra, for example)
var sizes$2 = /*#__PURE__*/fromEntries( /*#__PURE__*/size.map(function (s) {
  return [s, getSizePresetFromNextTokens('Icon', s === 'default' ? 'small' : s)];
}));

var presets = {
  200: {
    color: tokens$1.body200Color,
    fontFamily: tokens$1.body200Family,
    fontSize: tokens$1.body200Size,
    fontWeight: tokens$1.body200Weight,
    lineHeight: tokens$1.body200Height
  },
  300: {
    fontWeight: tokens$1.body300Weight,
    fontFamily: tokens$1.body300Family,
    color: tokens$1.body300Color,
    fontSize: tokens$1.body300Size,
    lineHeight: tokens$1.body300Height
  },
  400: {
    fontWeight: tokens$1.body400Weight,
    fontFamily: tokens$1.body400Family,
    color: tokens$1.body400Color,
    fontSize: tokens$1.body400Size,
    lineHeight: tokens$1.body400Height
  },
  500: {
    fontWeight: tokens$1.body500Weight,
    fontFamily: tokens$1.body500Family,
    color: tokens$1.body500Color,
    fontSize: tokens$1.body500Size,
    lineHeight: tokens$1.body500Height
  },
  600: {
    fontWeight: tokens$1.body600Weight,
    fontFamily: tokens$1.body600Family,
    color: tokens$1.body600Color,
    fontSize: tokens$1.body600Size,
    lineHeight: tokens$1.body600Height
  }
};
var aliases = {
  footnote: 200,
  small: 300,
  medium: 400
};
var sizes$1 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets);
var capsizes = capsizesJson.body;

var colors = {
  primary: {
    50: tokens.primary50,
    100: tokens.primary100,
    200: tokens.primary200,
    300: tokens.primary300,
    400: tokens.primary400,
    500: tokens.primary500,
    600: tokens.primary600,
    700: tokens.primary700,
    800: tokens.primary800,
    900: tokens.primary900,
    base: tokens.primaryBase
  },
  secondary: {
    100: tokens.secondary100,
    200: tokens.secondary200,
    300: tokens.secondary300,
    400: tokens.secondary400,
    500: tokens.secondary500,
    600: tokens.secondary600,
    700: tokens.secondary700,
    800: tokens.secondary800,
    900: tokens.secondary900,
    base: tokens.secondaryBase
  },
  neutral: {
    0: tokens.neutral0,
    100: tokens.neutral100,
    200: tokens.neutral200,
    300: tokens.neutral300,
    400: tokens.neutral400,
    500: tokens.neutral500,
    50: tokens.neutral50,
    550: tokens.neutral550,
    600: tokens.neutral600,
    700: tokens.neutral700,
    750: tokens.neutral750,
    800: tokens.neutral800,
    850: tokens.neutral850,
    900: tokens.neutral900,
    background: tokens.neutralBackground,
    backgroundDark: tokens.neutralBackgroundDark,
    card: tokens.neutralCard,
    disabled: tokens.neutralDisabled,
    secondaryText: tokens.neutralSecondaryText,
    stroke: tokens.neutralStroke,
    text: tokens.neutralText,
    textLight: tokens.neutralTextLight
  },
  success: {
    50: tokens.success50,
    100: tokens.success100,
    200: tokens.success200,
    300: tokens.success300,
    400: tokens.success400,
    500: tokens.success500,
    600: tokens.success600,
    700: tokens.success700,
    800: tokens.success800,
    900: tokens.success900,
    base: tokens.successBase
  },
  warning: {
    50: tokens.warning50,
    100: tokens.warning100,
    200: tokens.warning200,
    300: tokens.warning300,
    400: tokens.warning400,
    500: tokens.warning500,
    600: tokens.warning600,
    700: tokens.warning700,
    800: tokens.warning800,
    900: tokens.warning900,
    base: tokens.warningBase
  },
  danger: {
    50: tokens.danger50,
    100: tokens.danger100,
    200: tokens.danger200,
    300: tokens.danger300,
    400: tokens.danger400,
    500: tokens.danger500,
    600: tokens.danger600,
    700: tokens.danger700,
    800: tokens.danger800,
    900: tokens.danger900,
    base: tokens.dangerBase
  },
  info: {
    50: tokens.primary50,
    100: tokens.primary100,
    200: tokens.primary200,
    300: tokens.primary300,
    400: tokens.primary400,
    500: tokens.primary500,
    600: tokens.primary600,
    700: tokens.primary700,
    800: tokens.primary800,
    900: tokens.primary900,
    base: tokens.primaryBase
  },
  brandNavy: {
    100: tokens.brandNavy100,
    200: tokens.brandNavy200,
    300: tokens.brandNavy300,
    400: tokens.brandNavy400,
    500: tokens.brandNavy500,
    600: tokens.brandNavy600,
    700: tokens.brandNavy700,
    800: tokens.brandNavy800,
    900: tokens.brandNavy900
  },
  brandGreen: {
    100: tokens.brandGreen100,
    200: tokens.brandGreen200,
    300: tokens.brandGreen300,
    400: tokens.brandGreen400,
    500: tokens.brandGreen500,
    600: tokens.brandGreen600,
    700: tokens.brandGreen700,
    800: tokens.brandGreen800,
    900: tokens.brandGreen900
  },
  brandBrown: {
    100: tokens.brandBrown100,
    200: tokens.brandBrown200,
    300: tokens.brandBrown300,
    400: tokens.brandBrown400,
    500: tokens.brandBrown500,
    600: tokens.brandBrown600,
    700: tokens.brandBrown700,
    800: tokens.brandBrown800,
    900: tokens.brandBrown900
  },
  brandRed: {
    100: tokens.brandRed100,
    200: tokens.brandRed200,
    300: tokens.brandRed300,
    400: tokens.brandRed400,
    500: tokens.brandRed500,
    600: tokens.brandRed600,
    700: tokens.brandRed700,
    800: tokens.brandRed800,
    900: tokens.brandRed900
  },
  brandTan: {
    100: tokens.brandTan100,
    200: tokens.brandTan200,
    300: tokens.brandTan300,
    400: tokens.brandTan400,
    500: tokens.brandTan500,
    600: tokens.brandTan600,
    700: tokens.brandTan700,
    800: tokens.brandTan800,
    900: tokens.brandTan900
  },
  brandOrange: {
    100: tokens.brandOrange100,
    200: tokens.brandOrange200,
    300: tokens.brandOrange300,
    400: tokens.brandOrange400,
    500: tokens.brandOrange500,
    600: tokens.brandOrange600,
    700: tokens.brandOrange700,
    800: tokens.brandOrange800,
    900: tokens.brandOrange900
  },
  brandYellow: {
    100: tokens.brandYellow100,
    200: tokens.brandYellow200,
    300: tokens.brandYellow300,
    400: tokens.brandYellow400,
    500: tokens.brandYellow500,
    600: tokens.brandYellow600,
    700: tokens.brandYellow700,
    800: tokens.brandYellow800,
    900: tokens.brandYellow900
  },
  brandPurple: {
    100: tokens.brandPurple100,
    200: tokens.brandPurple200,
    300: tokens.brandPurple300,
    400: tokens.brandPurple400,
    500: tokens.brandPurple500,
    600: tokens.brandPurple600,
    700: tokens.brandPurple700,
    800: tokens.brandPurple800,
    900: tokens.brandPurple900
  },
  lightAlpha: {
    50: tokens.lightAlpha50,
    100: tokens.lightAlpha100,
    200: tokens.lightAlpha200,
    300: tokens.lightAlpha300,
    400: tokens.lightAlpha400,
    500: tokens.lightAlpha600,
    600: tokens.lightAlpha600,
    700: tokens.lightAlpha700,
    800: tokens.lightAlpha800,
    900: tokens.lightAlpha900
  },
  darkAlpha: {
    50: tokens.darkAlpha50,
    100: tokens.darkAlpha100,
    200: tokens.darkAlpha200,
    300: tokens.darkAlpha300,
    400: tokens.darkAlpha400,
    500: tokens.darkAlpha600,
    600: tokens.darkAlpha600,
    700: tokens.darkAlpha700,
    800: tokens.darkAlpha800,
    900: tokens.darkAlpha900
  },
  overlayLight: tokens.overlayLight,
  overlayDark: tokens.overlayDark,
  halo: {
    primary: tokens.haloPrimary,
    neutral: tokens.haloNeutral,
    warning: tokens.haloWarning,
    danger: tokens.haloDanger,
    success: tokens.haloSuccess
  },
  ring: {
    primary: tokens.ringPrimary,
    neutral: tokens.ringNeutral
  },
  border: {
    danger: tokens.borderDanger,
    disabled: tokens.borderDisabled,
    focus: tokens.borderFocus,
    focusDanger: tokens.borderFocusDanger,
    focusNeutral: tokens.borderFocusNeutral,
    focusSuccess: tokens.borderFocusSuccess,
    focusWarning: tokens.borderFocusWarning,
    idle: tokens.borderIdle,
    invalid: tokens.borderInvalid,
    invalidFocus: tokens.borderInvalidFocus,
    neutral: tokens.borderNeutral,
    primary: tokens.borderPrimary
  }
};

var radii = {
  200: tokens$2.radius200,
  300: tokens$2.radius300,
  350: tokens$2.radius350,
  400: tokens$2.radius400,
  450: tokens$2.radius450,
  500: tokens$2.radius500,
  550: tokens$2.radius550,
  900: tokens$2.radius900,
  round: tokens$2.radiusRound
};

var sizes = {
  25: tokens$3.size25,
  50: tokens$3.size50,
  75: tokens$3.size75,
  100: tokens$3.size100,
  150: tokens$3.size150,
  200: tokens$3.size200,
  250: tokens$3.size250,
  300: tokens$3.size300,
  350: tokens$3.size350,
  375: tokens$3.size375,
  400: tokens$3.size400,
  500: tokens$3.size500,
  525: tokens$3.size525,
  600: tokens$3.size600,
  700: tokens$3.size700,
  750: tokens$3.size750,
  800: tokens$3.size800,
  850: tokens$3.size850,
  900: tokens$3.size900,
  checkbox: {
    small: tokens$3.sizeCheckboxSmall,
    medium: tokens$3.sizeCheckboxMedium,
    large: tokens$3.sizeCheckboxLarge
  },
  radio: {
    small: tokens$3.sizeRadioSmall,
    medium: tokens$3.sizeRadioMedium,
    large: tokens$3.sizeRadioLarge
  }
};

var space = {
  0: tokens$4.size0,
  50: tokens$4.size50,
  100: tokens$4.size100,
  200: tokens$4.size200,
  300: tokens$4.size300,
  400: tokens$4.size400,
  500: tokens$4.size500,
  600: tokens$4.size600,
  700: tokens$4.size700,
  800: tokens$4.size800,
  900: tokens$4.size900,
  1000: tokens$4.size1000,
  1100: tokens$4.size1100
};

var typography = {
  fonts: {
    body: tokens$1.familyBody,
    brand: tokens$1.familyBrand,
    code: tokens$1.familyCode,
    display: tokens$1.familyDisplay
  },
  lineHeights: {
    50: tokens$1.height50,
    100: tokens$1.height100,
    200: tokens$1.height200,
    300: tokens$1.height300,
    400: tokens$1.height400,
    500: tokens$1.height500,
    600: tokens$1.height600,
    700: tokens$1.height700,
    800: tokens$1.height800,
    900: tokens$1.height900,
    1000: tokens$1.height1000
  },
  fontWeights: {
    100: tokens$1.weight100,
    300: tokens$1.weight300,
    400: tokens$1.weight400,
    500: tokens$1.weight500,
    600: tokens$1.weight600,
    700: tokens$1.weight700,
    body: tokens$1.weightBody,
    bodyBold: tokens$1.weightBodyBold,
    bodySemiBold: tokens$1.weightBodySemiBold,
    bodyMedium: tokens$1.weightBodyMedium,
    display: tokens$1.weightDisplay,
    heading: tokens$1.weightHeading,
    headingLight: tokens$1.weightHeadingLight
  },
  fontSizes: {
    50: tokens$1.size50,
    100: tokens$1.size100,
    200: tokens$1.size200,
    300: tokens$1.size300,
    400: tokens$1.size400,
    500: tokens$1.size500,
    600: tokens$1.size600,
    700: tokens$1.size700,
    800: tokens$1.size800,
    900: tokens$1.size900,
    1000: tokens$1.size1000,
    base: tokens$1.sizeBase
  },
  letterSpacings: {
    200: tokens$1.spacing200,
    300: tokens$1.spacing300,
    400: tokens$1.spacing400,
    500: tokens$1.spacing500,
    base: tokens$1.spacingBase
  }
};

export { colors, aliases$1 as headingAliases, capsizes$1 as headingCapsizes, presets$1 as headingPresets, sizes$3 as headingSizes, sizes$2 as iconSizes, radii, sizes, space, aliases as textAliases, capsizes as textCapsizes, presets as textPresets, sizes$1 as textSizes, typography };
